<template>
    <MenuList
        :menuList="menuList"
        @handleClicks="
            (index, event) => {
                event.stopPropagation();
                setTheme(index);
            }
        "
    />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class DownloadMenus extends Vue {
        activeIndex: number = 0;
        get menuList() {
            return {
                // container: "",
                list: [
                    { label: this.$t("defalut"), checked: this.activeTheme(0) },
                    { label: this.$t("purple"), checked: this.activeTheme(1) },
                    { label: this.$t("gray"), checked: this.activeTheme(2) },
                ],
            };
        }
        setTheme(type) {
            let storage = localStorage;
            let theme = storage.setItem("themeColor", type);
            let index = type;
            let colorList = [this.isDarkTheme ? "#7755FF" : "#017fff", "#3a4275", "#4f5359"];
            let hoverList = [this.isDarkTheme ? "#8F6CFF" : "#0177f0", "#252a4c", "#2a2d31"];
            document.body.style.setProperty("--themeColor", colorList[index]);
            document.body.style.setProperty("--themeHover", hoverList[index]);
            this.activeIndex = index;
            this.$emit("closeDrop");
        }
        activeTheme(index) {
            return this.activeIndex == index;
        }
        mounted() {
            this.activeIndex = ~~localStorage.getItem("themeColor") || 0;
        }
    }
</script>
<i18n>
{
  "zh": {
    "defalut": "默认",
    "purple": "深紫色",
    "gray": "深灰色"
  },
  "es": {
    "defalut": "Configuración predeterminada",
    "purple": "Morado oscuro",
    "gray": "Gris oscuro"
  },
  "jp": {
    "defalut": "デフォルト",
    "purple": "暗紫色",
    "gray": "暗灰色"
  },
  "fr": {
    "defalut": "défaut",
    "purple": "violet",
    "gray": "Gris"
  },
  "pt": {
    "defalut": "Padrão",
    "purple": "Roxo Escuro",
    "gray": "Cinza Escuro"
  },
  "de": {
    "defalut": "Voreinstellung",
    "purple": "Lila",
    "gray": "Grau"
  },
  "it": {
    "defalut": "Standard",
    "purple": "viola",
    "gray": "Grigio"
  },
  "en": {
    "defalut": "Default",
    "purple": "Dark Violet",
    "gray": "Dark Grey"
  },
  "tw": {
    "defalut": "默認",
    "purple": "深紫色",
    "gray": "深灰色"
  }
}
</i18n>
